export const METRIX_MERCHANTID_GETGO_US = 'getgo_us'
